import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["output"]

  connect() {
    this.outputTarget.textContent = "Stimulus connected 🚀"
  }

  greet() {
    this.outputTarget.textContent = `Clicked at ${new Date().toLocaleTimeString()}`
  }
}
